import {atom} from "recoil";

const domainAtom = atom({
    key: 'domain',
    default: ''
});

export default domainAtom;